import { DateTimeFormatter, Duration, Instant, LocalDate, OffsetDateTime } from '@js-joda/core';
/** @deprecated -- use zod schemas and call .encode() */
export function replacer(key, value) {
    // note that without looking at this[key] instead of value, .toJSON calls will be made
    if (value instanceof Instant) {
        return value.toJSON();
    }
    else if (value instanceof Duration) {
        return value.toJSON();
    }
    else if (value instanceof LocalDate) {
        return value.toJSON();
    }
    // if (typeof value === 'object' && value !== null && '_seconds' in value && '_nanos' in value) {
    //     const prototypeName = Object.getPrototypeOf(value)?.constructor?.name;
    //     log.warn('Found an object that looks and quacks like a Joda Instant, but it is not an instance of Instant', {
    //         key,
    //         value,
    //         parent: this,
    //         prototypeName,
    //     });
    // }
    return value;
}
export const ISO_8601_FULL_DATE = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
export const ISO_8601_DATE = /^\d{4}-\d\d-\d\d$/i;
export const ISO_8601_FULL_DURATION = /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d+[HMS])(\d+H)?(\d+M)?(\d+S)?)?$/i;
/** @deprecated -- use zod schemas and call .parse() or .safeParse() */
export function reviver(key, value) {
    try {
        if (typeof value === 'string') {
            if (value.match(ISO_8601_FULL_DATE)) {
                const odt = OffsetDateTime.parse(value, DateTimeFormatter.ISO_OFFSET_DATE_TIME);
                return odt.toInstant();
            }
            else if (value.match(ISO_8601_FULL_DURATION)) {
                return Duration.parse(value);
            }
            else if (value.match(ISO_8601_DATE)) {
                return LocalDate.parse(value);
            }
        }
    }
    catch {
        /**
         * Whelp.
         */
    }
    return value;
}
//# sourceMappingURL=serializer.js.map